const initCollapser = rootSelector => {
  $(`${rootSelector} .js-more, ${rootSelector} .js-collapse`).on('click', () => {
    $(`${rootSelector} .js-more`).toggleClass('invisible');
    $(`${rootSelector} .js-collapse`).toggleClass('invisible');
  });
};

const initSearchCollapser = blockId => {
  const $searchContainer = $(`#${blockId} .search-container`);
  document.querySelector(`#${blockId} .search-collapser`).addEventListener('click', () => {
    $searchContainer.toggle();
  });
};

export {initCollapser, initSearchCollapser};
